import MaterialTable from "@material-table/core";
import React, { useEffect, useState } from "react";
import MatTableHeader from "../../IntMaterialTableHeader/IntMaterialTableHeader";
import { quoteResultsDataInternal } from "../../api";
import LoaderComponent from "../../../LoaderComponent/LoaderComponent";
import { log } from "../../../Helper";
import QuoteResultDetailPanel from "../../QuoteResultDetailPanel";
import { sortByPriceWithCurrency } from "../../../utils/utils";
import { CustomToolTipQuoteResultDeleteIcon } from "../../utility/tooltip";
import InternalQuoteResultDeleteDialog from "../Dialog/InternalQuoteResultDeleteDialog";
import useFilterState from "../../../hooks/useFilterState";
import _ from "lodash";

const QuoteResultsMaterialTable = ({ tableName }) => {
  const [tableData, setTableData] = useState(Array(0));
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(8000);
  const [pageNumber, setPageNumber] = useState(0);
  const [
    selectedMachinesForDeleteQuoteResult,
    setselectedMachinesForDeleteQuoteResult,
  ] = useState([]);
  const [openQuoteResultDelete, setOpenQuoteResultDelete] =
    React.useState(false);

  const getTableData = async () => {
    setIsLoading(true);
    try {
      const response = await quoteResultsDataInternal(pageNumber, pageSize);
      setTableData(response);
    } catch (error) {
      log("Error occured while fetching quote results", error);
      setTableData(Array(0));
    }
    setIsLoading(false);
  };

  const handleOpenQuoteResultDeleteDialog = () => {
    setOpenQuoteResultDelete(true);
  };

  const handleCloseQuoteResultDeleteDialog = () => {
    setOpenQuoteResultDelete(false);
  };

  const handleQuoteResultDeleteQuoteDialog = (data) => {
    setselectedMachinesForDeleteQuoteResult(new Array(data));
    handleOpenQuoteResultDeleteDialog();
  };

  useEffect(() => {
    getTableData();
  }, []);

  const columns = [
    {
      title: "OrderPath Id",
      field: "orderPathId",
      sorting: true,
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Comar",
      field: "comar",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Pick-Up",
      field: "pickupLocation",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Destination",
      field: "destination",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Product",
      field: "product",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "DIM (meter)",
      field: "dimension",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Weight (kg)",
      field: "weight",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Amount",
      field: "amount",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
      customSort: (a, b) => {
        return sortByPriceWithCurrency(a.amount, b.amount);
      },
    },
    {
      title: "Announcement Date",
      field: "modifiedDate",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Provider(Won)",
      field: "providerDescr",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "",
      field: "fullProviderList",
      hidden: true,
    },
  ];

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  return (
    <div className="mt-[-2rem]">
      {isLoading && <LoaderComponent />}
      {!isLoading && (
        <div className="flex flex-col">
          <MatTableHeader getTableData={getTableData} />
          <MaterialTable
            columns={columnsWithFilter.map((col, index) => {
              if (
                col.tableData?.filterValue == "" ||
                col.tableData?.filterValue == null ||
                col.tableData?.filterValue == undefined
              ) {
                let colWithoutDefaultFilter = _.omit(
                  col,
                  "defaultFilter",
                  "tableData.filterValue"
                );
                return colWithoutDefaultFilter;
              } else {
                return {
                  ...col,
                  defaultFilter: col.tableData?.filterValue,
                };
              }
            })}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h6 className="left-[45%] absolute top-[40%] text-center">
                    No records to display
                  </h6>
                ),
              },
              pagination: {
                labelRowsPerPage: "Orders Per Page",
                labelRowsSelect: "Orders",
              },
            }}
            options={{
              rowStyle: {
                fontSize: 10,
              },
              draggable: false,
              selection: false,
              search: false,
              toolbar: false,
              showTitle: false,
              grouping: false,
              pageSize: 100,
              filtering: true,
              maxBodyHeight: 600,
              headerStyle: {
                backgroundColor: "#367c2b",
                fontWeight: "400",
                color: "white",
                position: "sticky",
                top: 0,
                zIndex: 10,
              },
              tableContainerStyle: {
                maxHeight: 600,
                overflow: "auto",
              },
              pageSizeOptions: [100, 500, 1000],
              actionsColumnIndex: -1,
              filterCellStyle: {
                flex: 1
              },
            }}
            title={"Internal Quote Results"}
            data={tableData}
            detailPanel={({rowData}) => {
              return (
                <QuoteResultDetailPanel
                  rowData={rowData}
                  getTableData={getTableData}
                />
              );
            }}
            onFilterChange={(filters) => {
              // Create a map of current filters for quick lookup
              const filterMap = new Map();
              filters.forEach((filter) => {
                filterMap.set(filter.column.tableData.id, filter.value);
              });

              // Iterate over all columns to ensure each one is checked if the value is present in the filter map
              columnsWithFilter.forEach((col, columnId) => {
                const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

                // Update the filter state for each column
                handleFilterChange(columnId, newValue);
              });
            }}
            onRowClick={(event, rowData, togglePanel) => {
              togglePanel();
            }}
            actions={[
              (rowData) => ({
                icon: () => {
                  let editColor = "black";
                  let title = "Delete Quote";
                  if (rowData.isEligibleToCancel === 1) {
                    editColor = "error";
                    title = "Delete Quote";
                  } else {
                    editColor = "disabled";
                    title = "Delete disabled";
                  }
                  return (
                    <CustomToolTipQuoteResultDeleteIcon
                      checkDisable={editColor}
                      title={title}
                    />
                  );
                },
                onClick: (event, rowData) => {
                  if (rowData.isEligibleToCancel === 1) {
                    handleQuoteResultDeleteQuoteDialog(rowData);
                  }
                },
              }),
            ]}
          />
          <InternalQuoteResultDeleteDialog
            openQuote={openQuoteResultDelete}
            handleCloseQuote={handleCloseQuoteResultDeleteDialog}
            selectedMachinesForDeleteQuoteResult={
              selectedMachinesForDeleteQuoteResult
            }
            getTableData={getTableData}
          />
        </div>
      )}
    </div>
  );
};

export default QuoteResultsMaterialTable;
